import type { CellContext } from '@tanstack/react-table'
import { StarIcon } from 'lucide-react'

import { useToast } from '@/hooks'
import {
  type Tag,
  type Transaction,
  useProjectMutations,
} from '@/modules/projects'
import { byFavorite, cn } from '@/utils'

export const FavoriteCell = ({ row }: CellContext<Transaction, Tag[]>) => {
  const { tags } = row.original
  const isFavorited = byFavorite({ tags })
  const { updateFavoriteTransaction } = useProjectMutations()
  const { errorToast } = useToast()

  return (
    <button
      type="button"
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation()
        updateFavoriteTransaction(row.original).catch((error) =>
          errorToast('Failed to update transaction', error),
        )
      }}
      className="hover:bg-neutral-100 p-1 rounded transition-colors cursor-pointer"
      aria-label={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
    >
      <StarIcon
        className={cn(
          'h-4 w-4 transition-colors',
          isFavorited ? 'fill-yellow-500 text-yellow-500' : 'text-neutral-400',
        )}
      />
    </button>
  )
}
